import one from "../../../assets/tools/1.svg";
import two from "../../../assets/tools/2.svg";
import three from "../../../assets/tools/3.svg";
import four from "../../../assets/tools/4.svg";

export const toolsList = [
  {
    icon: one,
    title: "Blog Headlines",
    content: "Write a better blog title with our A.I tool.",
  },
  {
    icon: two,
    title: "Blog Intros",
    content: "Generate a paragraph of blog content using Blog Intros tool",
  },
  {
    icon: three,
    title: "Blog Outline",
    content: "Need an attention-grabbing headline for your article?",
  },
  {
    icon: three,
    title: "Blog Conclusions",
    content: "Write a better conclusions with AI writing tool.",
  },
  {
    icon: two,
    title: "Content Rewriter",
    content: "Get AI writer to rewrite your sentence in a different way.",
  },
  {
    icon: four,
    title: "Product Description",
    content: "Need an attention-grabbing headline for your article?",
  },
  {
    icon: four,
    title: "PAS Copywriting Formula",
    content: "Get AI writer to rewrite your sentence in a different way.",
  },
  {
    icon: three,
    title: "Company About Us",
    content: "Write a better blog title with our AI tool.",
  },
];
